import { QueryRoute } from 'bernie-core';
import { Layer } from 'bernie-view';
import { UitkDialogContent, UitkFullscreenDialog } from 'uitk-react-dialog';
import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import * as React from 'react';

export const TermsAndConditionsDialog = ({ action, routeStore }) => {
  const closeAction = () => {
    routeStore.goBack();
  };

  return (
    <QueryRoute query={{ pwaDialog: 'couponTerms' }}>
      <Layer id="coupon-terms" onDismiss={closeAction}>
        <UitkFullscreenDialog strictFullscreen={true}>
          <UitkToolbar header="More about this offer" iconLabel="Close the dialog" action={closeAction} type={ToolbarType.CLOSE} />
          <UitkDialogContent>
            <div className="uitk-grid">
              <div className="uitk-cell all-cell-1-6" />
              <div className="uitk-cell all-cell-2-3">
                <div>
                  <p className="uitk-type-500 uitk-type-bold">How to use this promo code</p>
                  <p>
                    <li className="all-t-margin-two">Applies to single-room hotel bookings, up to a maximum savings of $150 per booking</li>
                    <li className="all-t-margin-two">You must choose pay now</li>
                    <li className="all-t-margin-two">Cannot be combined with flights, cars or activities</li>
                    <li className="all-t-margin-two">Travel dates must be between June 1, 2018 and June 30, 2020 (inclusive)</li>
                    <li className="all-t-margin-two">Only on select hotels - see Terms and Conditions below for full listing</li>
                  </p>
                </div>
                <div className="all-y-margin-three">
                  <p>{action.actionDetails.details}</p>
                </div>
              </div>
              <div className="uitk-cell all-cell-1-6" />
            </div>
          </UitkDialogContent>
        </UitkFullscreenDialog>
      </Layer>
    </QueryRoute>
  );
};
